import { useEffect, useState, useCallback } from 'react';
import { FormControl, Select, useColorModeValue, Text } from '@chakra-ui/react';

type DropdownProps = {
    items: string[];
    onChange: (value: string | undefined) => void;
    placeholder: string;
    required?: boolean;
    styles?: React.CSSProperties;
    classes?: string[];
    onOpen?: () => void;
    minWidth?: number;
    maxHeight?: number;
    disabled?: boolean;
    name?: string;
    value?: string;
};

export const Dropdown = ({
    items,
    onChange,
    placeholder,
    required,
    minWidth,
    maxHeight,
    styles,
    onOpen,
    classes,
    disabled,
    name,
    value,
}: DropdownProps) => {
    const [selectedItem, setSelectedItem] = useState<string | undefined>(value);

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const val = event.target.value;
        if (val === 'undefined' || val === '') {
            setSelectedItem(undefined);
            onChange(undefined);
        } else {
            setSelectedItem(val);
            onChange(val);
        }
    };

    useEffect(() => {
        setSelectedItem(value || undefined);
    }, [value]);

    const handleClick = useCallback(() => {
        if (onOpen) {
            onOpen();
        }
    }, [onOpen]);

    const formControlProps = {
        minWidth: minWidth ?? 150,
        maxWidth: 200,
        maxHeight: maxHeight,
        ...styles,
    };

    return (
        <FormControl
            isRequired={required}
            className={classes?.join(" ") ?? ''}
            isDisabled={disabled}
            style={formControlProps}
        >
            <Select
                isRequired={required}
                value={selectedItem}
                onChange={handleChange}
                onClick={handleClick}
                name={name}
                placeholder={`${placeholder}`}
                variant="outline"
                borderColor={useColorModeValue('gray.300', 'gray.600')}
                borderWidth="2px"
                _focus={{ borderColor: 'info.500' }}
                background={useColorModeValue('white', 'gray.800')}
                whiteSpace="nowrap"
                overflow="hidden"
                textOverflow="ellipsis"
                cursor={'pointer'}
            >
                {items.map((item, index) => (
                    <option key={index} value={item} style={{ whiteSpace: 'nowrap' }}>
                        {item}
                    </option>
                ))}
            </Select>
        </FormControl>
    );
};
